import React from 'react';
import RegionSelectorBar from 'ui/region-selector-bar';

const RegionSelectorBarTastic: React.FC = () => {
  return <RegionSelectorBar />;
};

export default RegionSelectorBarTastic;
